import { includes, without } from 'lodash-es';

export default {
  props: {
    attrs: {
      type: Object,
      required: true,
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
    privacyLink: {
      type: String,
      default: '',
    },
    hasGlobalConsent: {
      type: Boolean,
      default: true,
    },
    isSgphx: {
      type: Boolean,
      default: false,
    },
    checkboxListClass: {
      type: [String, Object, Array],
      default: '',
    },
  },

  emits: ['update:modelValue'],

  data() {
    let consents = ['newsletter', 'sms', 'voice', 'postal', 'social'];
    if (this.hasGlobalConsent) {
      consents = ['global', ...consents];
    }
    return {
      globalConsent: 'global',
      consents,
    };
  },

  computed: {
    field() {
      return { ...this.attrs, value: this.value, options: this.options };
    },

    formGroupProps() {
      return this.isSgphx ? { isSgphx: true } : {};
    },

    checkboxListProps() {
      return {
        ...(this.isSgphx ? { isSgphx: true } : {}),
        ...(this.checkboxListClass ? { class: this.checkboxListClass } : {}),
      };
    },

    options() {
      return this.consents.map((consent) => ({
        id: `${this.attrs.uniqueId ?? this.attrs.id}_${consent}`,
        dataCy: `marketingConsent-${consent}`,
        disabled: this.attrs.disabled,
        label:
          consent === this.globalConsent
            ? this.$t(`Form.marketingConsents.${consent}`, {
                privacyLink: `<a target='_blank' class='rcms_privacypol link link--text' href='${
                  this.privacyLink
                }'>${this.$t('Form.privacy')}</a>`,
              })
            : this.$t(`Form.marketingConsents.${consent}`),
        value: consent,
      }));
    },

    value: {
      get() {
        const value = [...this.modelValue];

        if (!this.hasGlobalConsent) {
          return value;
        }

        if (value.length > 0 && !value.includes('global')) {
          value.push('global');
        }

        return value;
      },
      set(value) {
        if (!this.hasGlobalConsent) {
          this.$emit('update:modelValue', value);
          return;
        }

        if (includes(value, this.globalConsent) && value.length === 1) {
          value = this.value.length > 1 ? [] : this.consents;
        } else if (!includes(value, this.globalConsent) && this.value.length > 0) {
          value = [];
        }

        this.$emit('update:modelValue', without(value, 'global'));
      },
    },
  },
};
